import ChallengeManagementPage from './ChallengeManagement.container';

export default ChallengeManagementPage;
